const controls = new Map();
let purgeRequiredOnRegister = false;

const invokeOrRequireFullPurge = (operation) => {
  if (controls.size) {
    controls.forEach((current) => operation(current));
    return;
  }
  // No repository module means no in-memory Trends cache can exist yet. Keep
  // a fail-closed barrier so a later module registration still starts empty.
  purgeRequiredOnRegister = true;
};

export const registerTrendsV2CacheControls = (keyOrControls, maybeControls = null) => {
  const nextControls = maybeControls || keyOrControls;
  const key = maybeControls ? String(keyOrControls) : nextControls;
  controls.set(key, nextControls);
  if (purgeRequiredOnRegister) {
    nextControls.purgeAll();
    purgeRequiredOnRegister = false;
  }
  return () => {
    if (controls.get(key) === nextControls) controls.delete(key);
  };
};

export const purgeAllTrendsV2 = () => invokeOrRequireFullPurge(
  (current) => current.purgeAll()
);

export const purgeTrendsV2ExceptSession = (sessionScope) => invokeOrRequireFullPurge(
  (current) => current.purgeExceptSession(sessionScope)
);

export const purgeTrendsV2ForHousehold = (householdId, family = null) => invokeOrRequireFullPurge(
  (current) => {
    try {
      current.purgeHousehold(householdId, family);
    } catch (error) {
      if (error?.code !== 'INVALID_SCOPE') throw error;
      current.purgeAll();
    }
  }
);

export const markTrendsV2ForHouseholdStale = (householdId, family) => invokeOrRequireFullPurge(
  (current) => {
    try {
      if (current.markHouseholdStale) current.markHouseholdStale(householdId, family);
      else current.purgeHousehold(householdId, family);
    } catch (error) {
      if (error?.code !== 'INVALID_SCOPE') throw error;
      current.purgeAll();
    }
  }
);
